import React from "react";
import { Pagination } from "@themesberg/react-bootstrap";

const PaginationComponent = (props) => {
  const { meta, handlePagination } = props;

  const renderPaginationItems = ({ totalPage, currentPage }) => {
    const items = [];
    let startPage = 1;
    const maxBlocks = 4;

    if (totalPage > maxBlocks) {
      if (currentPage > Math.floor(maxBlocks / 2) + 1) {
        startPage = currentPage - Math.floor(maxBlocks / 2);
        if (startPage + maxBlocks - 1 > totalPage) {
          startPage = totalPage - maxBlocks + 1;
        }
      }
    }

    for (
      let number = startPage;
      number <= totalPage && items.length < maxBlocks;
      number++
    ) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePagination(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (startPage > 1) {
      items.unshift(<Pagination.Ellipsis key={0} />);
    }

    if (startPage + maxBlocks - 1 < totalPage) {
      items.push(<Pagination.Ellipsis key={-1} />);
    }

    return items;
  };

  return (
    <>
      <Pagination>
        {meta?.previousPage === meta?.currentPage ? (
          <Pagination.Prev disabled>Prev</Pagination.Prev>
        ) : (
          <Pagination.Prev
            onClick={() => handlePagination(meta?.currentPage - 1)}
          >
            Prev
          </Pagination.Prev>
        )}
        {renderPaginationItems({
          totalPage: meta?.totalPage,
          currentPage: meta?.currentPage,
        })}
        {meta?.nextPage === meta?.currentPage ? (
          <Pagination.Next disabled>Next</Pagination.Next>
        ) : (
          <Pagination.Next
            onClick={() => handlePagination(meta?.currentPage + 1)}
          >
            Next
          </Pagination.Next>
        )}
      </Pagination>
    </>
  );
};

export default PaginationComponent;